import FilterChip from './FilterChip';
import { hapticSelection } from '../../utils/haptics';

/**
 * FilterChipsRow — горизонтальный ряд filter-chip-ов для Photo/Video catalog.
 *
 * Figma source: `318:4528` tags frame в generate-image (402×30).
 *   layoutMode=HORIZONTAL, itemSpacing 8, без padding (page-level px-4
 *   компенсирует body-margin).
 *   Horizontal scroll (overflow-x auto), scrollbar-hide (utility уже лежит в
 *   src/index.css, введён в stage 02).
 *
 * Чип «Все» приходит из backend как системная рубрика (`isSystem=true`,
 * `order=0`, slug='all-photo'/'all-video') — DES-76 / Stage 04b.6.
 * Первый chip закреплён слева, остальные rubrics скроллятся горизонтально.
 *
 * Props:
 *   rubrics      — массив {slug, label}
 *   selectedSlug — slug активного chip-а
 *   onSelect     — (slug) => void
 *
 * Edge case: rubrics пуст → возвращаем null (handoff §6 — «нет рубрик →
 * скрываем row»).
 */
export default function FilterChipsRow({ rubrics, selectedSlug, onSelect }) {
  if (!rubrics || rubrics.length === 0) return null;

  const [primaryRubric, ...scrollRubrics] = rubrics;
  const renderChip = (r) => (
    <FilterChip
      key={r.slug}
      label={r.label}
      selected={r.slug === selectedSlug}
      onClick={() => {
        if (r.slug !== selectedSlug) hapticSelection();
        onSelect(r.slug);
      }}
    />
  );

  return (
    <div
      className="flex items-center gap-2 overflow-hidden px-4"
      data-testid="filter-chips-row"
    >
      <div className="flex-shrink-0" data-testid="filter-chip-fixed">
        {renderChip(primaryRubric)}
      </div>
      <div
        data-testid="filter-chips-inner"
        className="flex min-w-0 flex-1 gap-2 overflow-x-auto scrollbar-hide whitespace-nowrap"
      >
        {scrollRubrics.map(renderChip)}
      </div>
    </div>
  );
}
